import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { AdminLayoutComponent } from 'app/theme/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from 'app/theme/auth-layout/auth-layout.component';
import { LoginComponent } from 'app/components/sessions/login/login.component';
import { RegisterComponent } from 'app/components/sessions/register/register.component';
import { SsoLoginComponent } from 'app/components/sessions/sso-login/sso-login.component';
import { SharedModule } from '@shared/shared.module';
import { Error404PageComponent } from 'app/components/error404-page/error404-page.component';
import { AuthGuardService } from '@core/services/authGuard.service';
import { AuditorhomeComponent } from 'app/components/auditorhome/auditorhome/auditorhome.component';
import { InvalidssocredentialComponent } from 'app/components/sessions/invalidssocredential/invalidssocredential.component';
import { MailDownloadComponent } from '@shared/components/mail-download/mail-download.component';

const routes: Routes = [

  /* {
    path: '',
    redirectTo: '/auth/login',
    pathMatch: 'full'
  }, */
  /* {
    path: 'auth',
    component: AuthLayoutComponent,
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      { path: 'login', component: LoginComponent, data: { title: 'Login', titleI18n: 'login' } },
      {
        path: 'register',
        component: RegisterComponent,
        data: { title: 'Register', titleI18n: 'register' },
      },
    ],
  }, */
  {
    path: 'login',
    component: LoginComponent,
    data: { title: 'Login', titleI18n: 'login' }
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: { title: 'Register', titleI18n: 'register' },
  },
  {
    path: 'invalidssocredential',
    component: InvalidssocredentialComponent,
    data: { title: 'Invalidssocredential', titleI18n: 'Invalidssocredential' },
  },
  {
    path: 'camsuserguide',
    component: MailDownloadComponent,
    data: { title: 'Login', titleI18n: 'login' }
  },
  {
    path: '',
    canActivate: [AuthGuardService],
    component: AdminLayoutComponent
    , children: [
      {
        path: ''
        //component: AdminLayoutComponent
        , children: [
          // {},
          {
            path: 'createauditprogram',
            loadChildren: () => import('app/components/createaudit/createaudit.module').then(m => m.CreateauditModule),

            data: { title: 'Create Audit Program', titleI18n: 'Create Audit Program' },
          },
          {
            path: 'auditprogramlist',
            loadChildren: () => import('app/components/auditprogramlist/auditprogramlist.module').then(m => m.AuditprogramlistModule),
            data: { title: 'Audit Program List', titleI18n: 'Audit Program List' },
          },
          {
            path: 'masters',
            loadChildren: () => import('app/components/masters/masters.module').then(m => m.MastersModule),
            data: { title: 'Masters', titleI18n: 'Masters' },
          },
          {
            path: 'auditorbench',
            loadChildren: () => import('app/components/auditorbench/auditorbench.module').then(m => m.AuditorbenchModule),
            data: { title: 'Auditor Bench', titleI18n: 'Auditor Bench' },
          },
          {
            path: 'approver',
            loadChildren: () => import('app/components/approver/approver.module').then(m => m.ApproverModule),
            data: { title: 'Approver', titleI18n: 'Approver' },
          },
          {
            path: 'audit-planning',
            loadChildren: () => import('app/components/audit-planning/audit-planning.module').then(m => m.AuditPlanningModule),
            data: { title: 'Audit Planning', titleI18n: 'Audit Planning' },
          },
          {
            path: 'auditorhome',
            loadChildren: () => import('app/components/auditorhome/auditorhome.module').then(m => m.AuditorhomeModule),
            data: { title: 'Auditor Home', titleI18n: 'Auditor Home' },
          },
          {
            path: 'auditeehome',
            loadChildren: () => import('app/components/auditeehome/auditeehome.module').then(m => m.AuditeehomeModule),
            data: { title: 'Auditee Home', titleI18n: 'Auditee Home' },
          },
          {
            path: 'auditeebench',
            loadChildren: () => import('app/components/auditeebench/auditeebench.module').then(m => m.AuditeebenchModule),
            data: { title: 'Auditee Bench', titleI18n: 'Auditee Bench' },
          },
          {
            path: 'usermaintenance',
            loadChildren: () => import('app/components/usermaintenance/usermaintenance.module').then(m => m.UsermaintenanceModule),
            data: { title: 'User Maintenance', titleI18n: 'User Maintenance' },
          },
          {
            path: 'workspace',
            loadChildren: () => import('app/components/workspace/workspace.module').then(m => m.WorkspaceModule),
            data: { title: 'Workspace', titleI18n: 'Workspace' },
          },

          {
            path: 'Admin',
            loadChildren: () => import('app/components/admin/admin.module').then(m => m.AdminModule),
            data: { title: 'Admin', titleI18n: 'Admin' },
          },
          {
            path: 'sessions',
            loadChildren: () => import('app/components/sessions/sessions.module').then(m => m.SessionsModule),
            data: { title: 'Sessions', titleI18n: 'sessions' },
          },
          {
            path: 'Report',
            loadChildren: () => import('app/components/reports/reports.module').then(m => m.ReportsModule),
            data: { title: 'Report', titleI18n: 'Report' },
          }
        ]
      }
    ],
  },
  {
    path: '**',
    component: Error404PageComponent,
  }
  // {
  //   path: '**',
  //   redirectTo: '404'
  // }
];

const COMPONENTS_DYNAMIC = [];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      preloadingStrategy: PreloadAllModules,
      onSameUrlNavigation: 'reload'
    }),
    SharedModule
  ],
  declarations: [LoginComponent, RegisterComponent, InvalidssocredentialComponent],
  entryComponents: COMPONENTS_DYNAMIC,
  exports: [RouterModule]
})
export class AuthRoutingModule { }
